import React from "react";
import { BrowserRouter as Router, Navigate, Route, Routes } from "react-router-dom";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import PopupForm from "./components/PopupForm";
import FloatingContactButtons from "./components/FloatingContactButtons";
import ContactSection from "./components/ContactSection";

import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import DirectorsDesk from "./components/DirectorsDesk";
import PrincipalDesk from "./pages/PrincipalDesk";
import MandatoryDisclosure from "./pages/MandatoryDisclosure";
import CbseDetail from "./pages/CbseDetail";
import Facilities from "./components/Facilities";
import Admission from "./pages/Admission";
import StudentTC from "./pages/StudentTC";
import FeeStructure from "./pages/FeeStructure";
import Gallery from "./pages/Gallery";
import VideoGallery from "./pages/VideoGallery";
import Enquiry from "./pages/Enquiry";
import News from "./pages/News";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfUse from "./pages/TermsOfUse";
import Sitemap from "./pages/Sitemap";

import { AdminAuthProvider } from "./admin/context/AdminAuthContext";
import ProtectedAdminRoute from "./admin/components/ProtectedAdminRoute";
import AdminLayout from "./admin/components/AdminLayout";
import AdminLogin from "./admin/pages/AdminLogin";
import Dashboard from "./admin/pages/Dashboard";
import AdminBanners from "./admin/pages/Banners";
import AdminGalleries from "./admin/pages/Galleries";
import AdminEnquiries from "./admin/pages/Enquiries";
import AdminNews from "./admin/pages/News";
import AdminFeeStructures from "./admin/pages/FeeStructures";
import AdminMandatoryDisclosures from "./admin/pages/MandatoryDisclosures";
import AdminVideoGallery from "./admin/pages/VideoGallery";
import AdminCbseDetails from "./admin/pages/CbseDetails";
import AdminTransferCertificates from "./admin/pages/TransferCertificates";
import "./admin/admin.css";

function PublicLayout({ children }) {
  return (
    <>
      <Navbar />
      {children}
      <Footer />
      <PopupForm />
      <FloatingContactButtons />
    </>
  );
}

function App() {
  return (
    <Router>
      <AdminAuthProvider>
        <Routes>
          <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
          <Route path="/about-us" element={<PublicLayout><AboutUs /></PublicLayout>} />
          <Route path="/director-desk" element={<PublicLayout><DirectorsDesk /></PublicLayout>} />
          <Route path="/principal-desk" element={<PublicLayout><PrincipalDesk /></PublicLayout>} />
          <Route path="/mandatory-disclosure" element={<PublicLayout><MandatoryDisclosure /></PublicLayout>} />
          <Route path="/cbse-details" element={<PublicLayout><CbseDetail /></PublicLayout>} />
          <Route path="/facilities" element={<PublicLayout><Facilities /></PublicLayout>} />
          <Route path="/admission" element={<PublicLayout><Admission /></PublicLayout>} />
          <Route path="/student-tc" element={<PublicLayout><StudentTC /></PublicLayout>} />
          <Route path="/fee-structure" element={<PublicLayout><FeeStructure /></PublicLayout>} />
          <Route path="/gallery" element={<PublicLayout><Gallery /></PublicLayout>} />
          <Route path="/enquiry" element={<PublicLayout><Enquiry /></PublicLayout>} />
          <Route path="/contact" element={<PublicLayout><ContactSection /></PublicLayout>} />
          <Route path="/news" element={<PublicLayout><News /></PublicLayout>} />
          <Route path="/privacy-policy" element={<PublicLayout><PrivacyPolicy /></PublicLayout>} />
          <Route path="/terms" element={<PublicLayout><TermsOfUse /></PublicLayout>} />
          <Route path="/terms-of-use" element={<PublicLayout><TermsOfUse /></PublicLayout>} />
          <Route path="/transfer-certificate" element={<PublicLayout><StudentTC /></PublicLayout>} />
          <Route path="/video-gallery" element={<PublicLayout><VideoGallery /></PublicLayout>} />
          <Route path="/sitemap" element={<PublicLayout><Sitemap /></PublicLayout>} />

          <Route path="/admin/login" element={<AdminLogin />} />
          <Route element={<ProtectedAdminRoute />}>
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="banners" element={<AdminBanners />} />
              <Route path="galleries" element={<AdminGalleries />} />
              <Route path="video-gallery" element={<AdminVideoGallery />} />
              <Route path="fee-structure" element={<AdminFeeStructures />} />
              <Route path="mandatory-disclosures" element={<AdminMandatoryDisclosures />} />
              <Route path="cbse-details" element={<AdminCbseDetails />} />
              <Route path="transfer-certificates" element={<AdminTransferCertificates />} />
              <Route path="enquiries" element={<AdminEnquiries />} />
              <Route path="news" element={<AdminNews />} />
            </Route>
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AdminAuthProvider>
    </Router>
  );
}

export default App;
